import React, { useState } from 'react';
import AnimatedPageContainer from '../../assets/containers/AnimatedPageContainer';
import CustomSelect from '../../assets/components/CustomSelect';
import CustomInput from '../../assets/components/customInput';
import Classes from './style.module.css'
import CustomTextArea from '../../assets/components/CustomTextArea';

import TicketFileUploader from './TicketFileUploader';
import CustomButton from '../../assets/components/CustomButton';
import Loading from '../../assets/containers/loadingDialog';

import { useNavigate } from 'react-router-dom';
import errorHandler from '../../assets/utils/ErrorHandler';
import { createTicket } from '../../assets/services/apiServices';
import toast from 'react-hot-toast';
import CustomHint from '../../assets/containers/CustomHint';

const CreateTicket = () => {
    const navigate = useNavigate();
    const [subject, setsubject] = useState("به روزرسانی شماره تلفن")
    const [fullName, setFullName] = useState("");
    const [codeMeli, setCodeMeli] = useState("");
    const [codePersoneli, setCodePersoneli] = useState("");
    const [pic, setPic] = useState("");
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false)

    const handleSubmit = async () => {
        const data = {
            "subject": "PhoneUpdate",
            "guest": {
                "fullName": fullName,
                "codeMeli": codeMeli,
                "codePersoneli": codePersoneli,
                "picPersoneli": pic ? pic.name : ""
            },
            "message": message
        }
        setIsLoading(true)
        try {
            const response = await createTicket(data);
            toast.success("تیکت با موفقیت ساخته شد.")
            navigate(`/createdTicket/${response.data._id}`)
        } catch (err) {
            errorHandler(err)
        } finally {
            setIsLoading(false)
        }
    }

    const hint = `
    <div>
    جهت بروزرسانی شماره تلفن بدون ورود به حساب کاربری، در بخش پیام حتما
    <strong>
    شماره جدید
    </strong>
    را قید کنید.
    </br>
    جهت احراز هویت 
    <strong>        
    عکس کارت پرسنلی      
    </strong>
    خود را نیز ارسال کنید.
    </div>
    `
    return (
        <AnimatedPageContainer>
            <div className='customContainer'>
                <div className={Classes.container}>
                    <CustomSelect
                        label={"موضوع"}
                        handleChange={(value) => console.log(value)}
                        value={"به روزرسانی شماره تلفن"}
                        options={["به روزرسانی شماره تلفن"]}
                        name={"relation"}
                        disabled
                    />
                    {
                        subject === "به روزرسانی شماره تلفن" &&
                        <div className='mt-4'>
                            <CustomHint
                                hint={hint}
                            />
                        </div>
                    }
                    <CustomInput
                        placeholder={"نام و نام‌خانوادگی"}
                        label={"نام و نام‌خانوادگی"}
                        value={fullName}
                        handleChange={(value) => setFullName(value)}
                        name={"name&familyName"}
                    />
                    <CustomInput
                        placeholder={"کد ملی"}
                        label={"کد ملی"}
                        value={codeMeli}
                        handleChange={(value) => setCodeMeli(value)}
                        name={"name&familyName"}
                        type={'number'}
                    />
                    <CustomInput
                        placeholder={"کد پرسنلی"}
                        label={"کد پرسنلی"}
                        value={codePersoneli}
                        handleChange={(value) => setCodePersoneli(value)}
                        name={"name&familyName"}
                        type={"number"}
                    />
                    <CustomTextArea
                        label={"پیام"}
                        value={message}
                        handleChange={(value) => setMessage(value)}
                    />
                    <TicketFileUploader pic={pic} setPic={setPic} />
                    {isLoading ?
                        <div className='d-flex justify-content-center my-4'>
                            <Loading />
                        </div>
                        :
                        <CustomButton
                            text={"ثبت"}
                            styles={{ marginTop: '36px' }}
                            clickHandler={handleSubmit}
                        />
                    }
                </div>

            </div>
        </AnimatedPageContainer>
    )
}

export default CreateTicket